<script lang="ts">
  import { IntersectionObserver } from "@opera-gx/components/v6";

  import Image from "../components/Image.svelte";

  export let items;
  export let key = "";

  const url = items?.url;
  const imageMobile = items?.banners?.imageMobile?.url;
  const imageDesktop = items?.banners?.imageDesktop?.url;
</script>

<style>
  .banner {
    width: 100%;
    height: 100%;
  }
</style>

<IntersectionObserver once={true} let:intersecting>
  {#if intersecting}
    <a href={url} class="gx-section_{key} pl-left pr-right flex flex-col gap-4">
      <div class="banner">
        <picture>
          <source media="(min-width: 501px)" srcset={imageDesktop} />
          <Image src={imageMobile} />
        </picture>
      </div>
    </a>
  {/if}
</IntersectionObserver>
